<template>
  <div>
    <section class="page-content">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">Franchises, Membership & Associations</h1>
            </article>
            <article class="input-section form-section">
              <div class="table-scroll">
                <table width="100%">
                  <thead>
                  <tr>
                    <th colspan="4">
                      Please check all that apply:
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      1-800-PACKOUTS
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="packout1800"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.packout1800"
                      >
                    </td>
                    <td>
                      Lionsbridge/CCA Global
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="lionsbridge"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.lionsbridge"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      1-800-Water Damage
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="waterDamage1800"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.waterDamage1800"
                      >
                    </td>
                    <td>
                      Nexxus Solutions Group, LLC
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="nexxusSolutions"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.nexxusSolutions"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      AdvantaClean
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="advantaClean"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.advantaClean"
                      >
                    </td>
                    <td>
                      Paul Davis Restoration
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="paulDavisRestoration"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.paulDavisRestoration"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Alacrity
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="alacrity"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.alacrity"
                      >
                    </td>
                    <td>
                      Puroclean
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="puroclean"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.puroclean"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Code Blue
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="codeBlue"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.codeBlue"
                      >
                    </td>
                    <td>
                      Rainbow International
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="rainbowInternational"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.rainbowInternational"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      Crawford Contractor Connection
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="crawfordContractor"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.crawfordContractor"
                      >
                    </td>
                    <td>
                      RIA
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="ria"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.ria"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      DKI
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="dki"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.dki"
                      >
                    </td>
                    <td>
                      Service Master
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="serviceMaster"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.serviceMaster"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      ICRA & Associations
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="icra"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.icra"
                      >
                    </td>
                    <td>
                      ServPro
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="servPro"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.servPro"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      IMACC
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="imacc"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.imacc"
                      >
                    </td>
                    <td>
                      Other (explain):
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="coverages"
                        value
                        class="orep-radio position-relative"
                        v-model="rcApplication.membershipOther"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>              
            </article>

            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">VEHICLE EXPOSURES</h1>
            </article>
            <article class="input-section form-section">

              <div class="row">
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Number of company owned vehicles (list below)</label>
                      <input
                        type="number"
                        name="numberOfCompanyOwnedVehicles"
                        v-model="rcApplication.numberOfCompanyOwnedVehicles"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >

                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Number of drivers:</label>
                      <input
                        type="number"
                        name="numberOfDrivers"
                        v-model="rcApplication.numberOfDrivers"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >
                    </label>
                  </div>
                </div>

              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Private Pass:</label>
                      <input
                        type="number"
                        name="privatePass"
                        v-model="rcApplication.privatePass"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >

                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Light Trucks:</label>
                      <input
                        type="number"
                        name="lightTrucks"
                        v-model="rcApplication.lightTrucks"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >
                    </label>
                  </div>
                </div>               
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Medium Trucks:</label>
                      <input
                        type="number"
                        name="debuggingTscm"
                        v-model="rcApplication.mediumTrucks"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Heavy Trucks:</label>
                      <input
                        type="number"
                        name="heavyTrucks"
                        v-model="rcApplication.heavyTrucks"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >

                    </label>
                  </div>
                </div>                
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Heavy Truck Tractors:</label>
                      <input
                        type="number"
                        name="heavyTruckTractors"
                        v-model="rcApplication.heavyTruckTractors"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Extra-Heavy Trucks:</label>
                      <input
                        type="number"
                        name="extraHeavyTruck"
                        v-model="rcApplication.extraHeavyTruck"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Extra-Heavy Truck Tractors:</label>
                      <input
                        type="number"
                        name="extraHeavyTruckTractors"
                        v-model="rcApplication.extraHeavyTruckTractors"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >

                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="radio">
                    <label class="align-items-center w-100">
                      <label class="orep-label mb-0 mr-4 w-100">Trailers:</label>
                      <input
                        type="number"
                        name="debuggingTscm"
                        v-model="rcApplication.trailers"
                        class="orep-text-input ml-3 mr-1 w-100"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        style="width: 150px"
                      >
                    </label>
                  </div>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Do you have a written procedure for the screening and hiring of drivers?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="writtenProcedureForTheScreening"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.writtenProcedureForTheScreening"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="writtenProcedureForTheScreening"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.writtenProcedureForTheScreening"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('writtenProcedureForTheScreening')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('writtenProcedureForTheScreening') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.writtenProcedureForTheScreening == true || rcApplication.writtenProcedureForTheScreening === 'true'">
                <label for class="orep-label">
                  If yes, please provide details:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.writtenProcedureForTheScreening == true || rcApplication.writtenProcedureForTheScreening === 'true'"
                  name="writtenProcedureForTheScreeningDetails"
                  v-model="rcApplication.writtenProcedureForTheScreeningDetails"
                >
              </div>

            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Are MVR’s pulled on all drivers?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="mvrsPulled"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.mvrsPulled"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="mvrsPulled"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.mvrsPulled"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('mvrsPulled')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('mvrsPulled') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.mvrsPulled == true || rcApplication.mvrsPulled === 'true'">
                <label for class="orep-label">
                  If yes, please provide details:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.mvrsPulled == true || rcApplication.mvrsPulled === 'true'"
                  name="mvrsPulledDetails"
                  v-model="rcApplication.mvrsPulledDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    As part of a formal driver qualification program are MVR’s reviewed using set criteria at least annually by the insured?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="formalDriverQualificationMvr"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.formalDriverQualificationMvr"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="formalDriverQualificationMvr"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.formalDriverQualificationMvr"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('formalDriverQualificationMvr')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('formalDriverQualificationMvr') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.formalDriverQualificationMvr == true || rcApplication.formalDriverQualificationMvr === 'true'">
                <label for class="orep-label">
                  If MVR’s are reviewed but not by the insured, please identify who reviews them:
                </label>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.formalDriverQualificationMvr == true || rcApplication.formalDriverQualificationMvr === 'true'"
                  name="formalDriverQualificationMvrDetails"
                  v-model="rcApplication.formalDriverQualificationMvrDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Is there a vehicle maintenance program in place?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isVehicleMaintenance"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.isVehicleMaintenance"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="isVehicleMaintenance"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.isVehicleMaintenance"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('isVehicleMaintenance')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('isVehicleMaintenance') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.isVehicleMaintenance == true || rcApplication.isVehicleMaintenance === 'true'">
                <label for class="orep-label">
                  If yes, please provide details:
                </label>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please explain:"
                  v-if="rcApplication.isVehicleMaintenance == true || rcApplication.isVehicleMaintenance === 'true'"
                  name="isVehicleMaintenanceDetails"
                  v-model="rcApplication.isVehicleMaintenanceDetails"
                >
              </div>

            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Do employees use personal vehicles in business?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="employeesUsePersonalVehicles"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.employeesUsePersonalVehicles"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="employeesUsePersonalVehicles"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.employeesUsePersonalVehicles"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('employeesUsePersonalVehicles')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('employeesUsePersonalVehicles') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.employeesUsePersonalVehicles == true || rcApplication.employeesUsePersonalVehicles === 'true'">
                <label for class="orep-label">
                  If yes, list percentage of employees who use their own vehicles:
                </label>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please explain:"
                  v-if="rcApplication.employeesUsePersonalVehicles == true || rcApplication.employeesUsePersonalVehicles === 'true'"
                  name="employeesUsePersonalVehiclesDetails"
                  v-model="rcApplication.employeesUsePersonalVehiclesDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Do you use owner/operators?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouUseOwnerOperators"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doYouUseOwnerOperators"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouUseOwnerOperators"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doYouUseOwnerOperators"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doYouUseOwnerOperators')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouUseOwnerOperators') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.doYouUseOwnerOperators == true || rcApplication.doYouUseOwnerOperators === 'true'">
                <label for class="orep-label">
                  If yes, please describe:
                </label>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please explain:"
                  v-if="rcApplication.doYouUseOwnerOperators == true || rcApplication.doYouUseOwnerOperators === 'true'"
                  name="hasAnyMemberInvolvedInPropertyPreservationDetails"
                  v-model="rcApplication.doYouUseOwnerOperatorsDetails"
                >
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Do you allow employees to take company vehicles home?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouAllowEmployeesCompanyVehicles"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doYouAllowEmployeesCompanyVehicles"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="doYouAllowEmployeesCompanyVehicles"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.doYouAllowEmployeesCompanyVehicles"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('doYouAllowEmployeesCompanyVehicles')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouAllowEmployeesCompanyVehicles') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    If you allow employees to take company vehicles home, are they allowed to drive the vehicles during non-work hours?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="employeesAllowToTakeVehiclesHome"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.employeesAllowToTakeVehiclesHome"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="employeesAllowToTakeVehiclesHome"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.employeesAllowToTakeVehiclesHome"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('employeesAllowToTakeVehiclesHome')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('employeesAllowToTakeVehiclesHome') | filterText }}</span>
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Do you have a written policy regarding the use of cell phones while operating vehicles?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="writtenPolicyRegardingCellPhone"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.writtenPolicyRegardingCellPhone"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="writtenPolicyRegardingCellPhone"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.writtenPolicyRegardingCellPhone"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('writtenPolicyRegardingCellPhone')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('writtenPolicyRegardingCellPhone') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.writtenPolicyRegardingCellPhone == true || rcApplication.writtenPolicyRegardingCellPhone === 'true'">
                <label for class="orep-label">
                  If yes, please describe:
                </label>
                <input
                  type="text"
                  class="orep-text-input js-orep-input"
                  placeholder="Please explain:"
                  v-if="rcApplication.writtenPolicyRegardingCellPhone == true || rcApplication.writtenPolicyRegardingCellPhone === 'true'"
                  name="writtenPolicyRegardingCellPhoneDetails"
                  v-model="rcApplication.writtenPolicyRegardingCellPhoneDetails"
                >
              </div>
            </article>

            <article class="d-flex flex-column justify-content-center form-heading title-section form-section">
              <h1 class="font-weight-bold text-center w-75">PROPERTY OF OTHERS / BAILEES EXPOSURES</h1>
            </article>
            <article class="input-section form-section">
              <div class="table-scroll">
                <table width="100%">
                  <thead>
                  <tr>
                    <th>
                      Sublimit(s) of Insurance
                    </th>
                    <th>
                      Aggregate Sublimit of Insurance
                    </th>
                    <th>
                    </th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>
                      $100,000
                    </td>
                    <td>
                      $100,000
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="propertyOfOthersBaileesExposures"
                        value="100K/100K"
                        class="orep-radio position-relative"
                        v-validate="'included:100K/100K,250K/250K,500K/500K,750K/750K,1M/1M'"
                        v-model="rcApplication.propertyOfOthersBaileesExposures"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      $250,000
                    </td>
                    <td>
                      $250,000
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="propertyOfOthersBaileesExposures"
                        value="250K/250K"
                        class="orep-radio position-relative"
                        v-model="rcApplication.propertyOfOthersBaileesExposures"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      $500,000
                    </td>
                    <td>
                      $500,000
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="propertyOfOthersBaileesExposures"
                        value="500K/500K"
                        class="orep-radio position-relative"
                        v-model="rcApplication.propertyOfOthersBaileesExposures"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      $750,000
                    </td>
                    <td>
                      $750,000
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="propertyOfOthersBaileesExposures"
                        value="750K/750K"
                        class="orep-radio position-relative"
                        v-model="rcApplication.propertyOfOthersBaileesExposures"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td>
                      $1,000,000
                    </td>
                    <td>
                      $1,000,000
                    </td>
                    <td>
                      <input
                        type="checkbox"
                        name="propertyOfOthersBaileesExposures"
                        value="1M/1M"
                        class="orep-radio position-relative"
                        v-model="rcApplication.propertyOfOthersBaileesExposures"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>              
            </article>

            <article class="input-section form-section">
              <label for class="orep-label">
                What is the maximum value of property of others that you store at any one time:
              </label>
              <input
                type="text"
                class="orep-text-input w-100"
                name="maxValueOfProperty"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                v-model="rcApplication.maxValueOfProperty"
              >
              <span
                v-show="errors.has('maxValueOfProperty')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('maxValueOfProperty') | filterText }}</span>
            </article>

            <article class="input-section form-section">
              <label for class="orep-label">
                How many storage locations do you have?
              </label>
              <input
                type="text"
                class="orep-text-input w-100"
                name="howManyStorageLocations"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                v-model="rcApplication.howManyStorageLocations"
              >
              <span
                v-show="errors.has('howManyStorageLocations')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('howManyStorageLocations') | filterText }}</span>
            </article>

            <article class="input-section form-section">
              <label for class="orep-label">
                What is the typical number of pack-outs per year?
              </label>
              <input
                type="text"
                class="orep-text-input w-100"
                name="typicalNumberOfPackOut"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                v-model="rcApplication.typicalNumberOfPackOut"
              >
              <span
                v-show="errors.has('typicalNumberOfPackOut')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('typicalNumberOfPackOut') | filterText }}</span>
            </article>

            <article class="input-section form-section">
              <label for class="orep-label">
                How many storage locations are located in a 100 year flood plain or in an area subject to periodic ponding or flooding?
                Please provide details:
              </label>
              <input
                type="text"
                class="orep-text-input w-100"
                name="howManyStorageLocationsIn100Year"
                v-validate="'required'"
                @input="validateBeforeSubmit()"
                v-model="rcApplication.howManyStorageLocationsIn100Year"
              >
              <span
                v-show="errors.has('howManyStorageLocationsIn100Year')"
                class="help is-danger form-errors text-danger"
              >{{ errors.first('howManyStorageLocationsIn100Year') | filterText }}</span>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    Has the applicant ever been subject to any claim for damage to property in your care, custody or control by any client or other third party?                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantSubjectToClaimDamage"
                          value="true"
                          v-validate="'required'"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasApplicantSubjectToClaimDamage"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                          type="radio"
                          name="hasApplicantSubjectToClaimDamage"
                          value="false"
                          class="orep-radio"
                          @change="validateBeforeSubmit()"
                          v-model="rcApplication.hasApplicantSubjectToClaimDamage"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                    v-show="errors.has('hasApplicantSubjectToClaimDamage')"
                    class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasApplicantSubjectToClaimDamage') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-12" v-if="rcApplication.hasApplicantSubjectToClaimDamage == true || rcApplication.hasApplicantSubjectToClaimDamage === 'true'">
                <label for class="orep-label">
                  If yes, please provide details:
                </label>
                <input
                  type="text"
                  placeholder="Please explain:"
                  class="orep-text-input js-orep-input"
                  v-if="rcApplication.hasApplicantSubjectToClaimDamage == true || rcApplication.hasApplicantSubjectToClaimDamage === 'true'"
                  name="hasApplicantSubjectToClaimDamageDetails"
                  v-model="rcApplication.hasApplicantSubjectToClaimDamageDetails"
                >
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'rc-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button class="pagination-dots" @click="navigateToOne()"></button>
            <button class="pagination-dots" @click="navigateToPrev('rc-application-2')"></button>
            <button class="pagination-dots" @click="navigateToPrev('rc-application-3')" :disabled="!state.pageThreeIsValid"></button>
            <span class="pagination-dots pagination-current"></span>
            <button class="pagination-dots" @click="navigateToNext('rc-application-5')" :disabled="!state.pageThreeIsValid || !state.pageFourIsValid"></button>
            <button
              class="pagination-dots"
              @click="navigateToNext('rc-application-6')"
              :disabled="!state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid">
            </button>

          </article>
          <button type="submit" :disabled="!state.pageFourIsValid"
            :class="{submitDisabled: !state.pageFourIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('rc-application-5')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import Datepicker from 'vuejs-datepicker';
import {APP_STATUS, STATES, STATUS} from "../../utils/constants";

var moment = require('moment')
export default {
  name: "rc-application-4",
  computedDates () {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    rcApplication() {
      return this.$store.state.rcApplication.rcApplication;
    },
    state() {
      return this.$store.state.rcApplication;
    },
    errorMsg() {
      return this.$store.state.rcApplication.errorMsg;
    },
  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    navigateToOne() {
      this.$router.push({
        name: "rc-application-1"
      });
    },

    navigateToPrev(routeName) {
      this.$router.push({
        name: routeName
      });
    },
    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageFourIsValid = true;
          return;
        }
        this.state.pageFourIsValid = false;
      });
    }
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td, table th {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
